import getSubdomain from './getSubdomain'
import getCurrentMainDomain from './getCurrentMainDomain'

export default function isInSubdomain(...subdomains) {
  return !!getCurrentMainDomain() && subdomains.includes(getSubdomain())
}
